import { ChangeNameDocument, ChangeNameDocumentType, FileInfo } from 'cpfr-common';
import { uploadFilesToRequestedUrls } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';

export type fileUpload = 'id' | 'proofOfIdentityChange';

export const fileTypes = {
    id: ChangeNameDocumentType.IDENTITY_DOCUMENT,
    proofOfIdentityChange: ChangeNameDocumentType.PROOF_OF_IDENTITY_CHANGE,
};

type DocumentList = {
    id: File[];
    proofOfIdentityChange: File[];
    proofOfAddress: File[];
};

export const uploadFilesToMediaStorage = (documentsValues: DocumentList): Promise<ChangeNameDocument>[] =>
    Object.entries(documentsValues)
        .filter((value) => value[1].length)
        .map(async (value: [string, File[]]) => {
            return {
                fileId: await uploadFilesToRequestedUrls(value[1], CpDataApi),
                type: fileTypes[value[0] as fileUpload],
            };
        });

export const getSeparatedFilesIds = (mediaStorageFilesIds: ChangeNameDocument[]): FileInfo[] =>
    mediaStorageFilesIds.reduce((acc: FileInfo[], cur) => {
        return acc.concat(
            cur.fileId.map((nestedFileId: string) => {
                return { fileId: nestedFileId, type: cur.type };
            }),
        );
    }, []);
